const schema = [
  {
    type: 'meta',
    logo: '/custom-forms/icope-logo.jpg',
    title: 'Expression of interest',
    content: `
    <p>
    Welcome
    </p>
    <p>
    Thank you for your interest in the iCOPE Digital Screening Platform as part of the Commonwealth Government's National Perinatal Mental Health Check.
    </p>
    <p>
    The following questions are designed to enable us to undertake an initial scoping of the size and needs of your hospital or healthcare setting. We will also seek to identify the key personnel with whom we can collaborate to support the successful implementation of iCOPE within yoru healthcare setting.
    </p>
    <p>
    The survey is not expected to take more than ten minutes of your time.
    </p>
    <p>
    You will also be provided with a copy of your survey responses upon submission, and this will be emailed to you for your records.
    </p>`
  },
  {
    type: 'submit',
    content: `
      <h1>
      Thank you for your time</h1>
      <p>
      You'll receive a copy of this form in your email.
      </p>
      <br />
      <img style="max-width:160px" src="data:image/png;base64,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">
      <p>
      Dr. Nicole Highet<br />
      Founder and Executive Director<br />
      Centre of Perinatal Excellence
      </p>
      `
  },
  {
    type: 'accordion',
    label: 'Details of Maternity Service',
    content: `
    <p>
    The first set of questions pertain to the facility where maternity care is provided.<br />
    This includes assessing the size and number of locations that exist under this service.
    </p>`,
    fields: {
      maternityServiceType: {
        component: 'InputSelectOther',
        options: [
          {
            label: 'Public Maternity Hospital'
          },
          {
            label: 'Maternal & Child Health Centre'
          },
          {
            label: 'Other (with free-text)',
            value: 'other'
          }
        ],
        label: 'Service type',
        properties: {
          columnSize: 12
        },
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      organisation: {
        component: 'InputText',
        label: 'Parent Organisation',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      streetAddress: {
        component: 'InputText',
        label: 'Street Address of Parent Organisation',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      suburb: {
        component: 'InputText',
        label: 'Suburb of Parent Organisation',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      state: {
        component: 'InputEnum',
        enum: 'states',
        label: 'State of Parent Organisation',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      postalCode: {
        component: 'InputText',
        label: 'Postcode of Parent Organisation',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      website: {
        component: 'InputText',
        label: 'Parent Organisation website',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      facilities: {
        component: 'InputTextMultiple',
        label:
          'Name of facilities where you would like to implement the iCOPE Digital Screening',
        placeholder: 'Facility name',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      births: {
        component: 'InputText',
        label: 'How many births/clients per year does this Service provide?',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      workforceSize: {
        component: 'InputNumber',
        label:
          'An approximately what is the size of the workforce who would be in involved in the provision of screening in/across your Service?'
      }
    }
  },
  {
    type: 'accordion',
    label: 'About your clients',
    content: `
    <p>
    The next set of questions pertain to the cultural backgrounds and needs of clients to whom you provide maternity care.
    </p>`,
    fields: {
      nonEnglishSpeakers: {
        component: 'InputSelectOther',
        label:
          'Approximately what proportion of your clients/patients would you estimate to be from Non-English speaking backgrounds?*',
        options: [
          {
            label: 'Hardly any clients (Less than 5%)'
          },
          {
            label: 'Less than a quarter (5% - 25%)'
          },
          {
            label: 'A quarter to a half (26% - 50%)'
          },
          {
            label: 'Around half (50%)'
          },
          {
            label: 'Half to three quarters (56% - 75%)'
          },
          {
            label: 'Over three quarters (76% - 95%)'
          },
          {
            label: 'Almost all clients (More than 95%)'
          }
        ],
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      languages: {
        component: 'InputTextMultiple',
        label:
          'The iCOPE Digital Screening Platform enables screening to be provided in multiple languages. Please list below the key languages required to facilitate screening for clients in your Service (in order most common languages).',
        placeholder: 'Language'
      },
      aboriginalClients: {
        component: 'InputSelectOther',
        label:
          'Thinking about clients from Aboriginal and Torres Strait Islander backgrounds, approximately what proportion of these clients would be represented in your Service?*',
        options: [
          {
            label: 'Hardly any clients (Less than 5%)'
          },
          {
            label: 'Less than a quarter (5% - 25%)'
          },
          {
            label: 'A quarter to a half (26% - 50%)'
          },
          {
            label: 'Around half (50%)'
          },
          {
            label: 'Half to three quarters (56% - 75%)'
          },
          {
            label: 'Over three quarters (76% - 95%)'
          },
          {
            label: 'Almost all clients (More than 95%)'
          }
        ]
      },
      clientOther: {
        component: 'InputText',
        label:
          'Is there any other information about your clients that you wish to add?'
      }
    }
  },
  {
    type: 'accordion',
    label: 'Current Screenning Practice for Perinatal Mental Heath',
    content: `
    <p>
    The following questions are designed to enable us to understand current screening practices surrounding perinatal mental health in your setting.
    </p>`,
    fields: {
      screening: {
        component: 'InputSelectOther',
        label:
          'Are women routinely screening for emotional and mental health within your Service?',
        options: [
          {
            label: 'Yes, all women are routinely screened'
          },
          {
            label: 'Only those considered at risk are screened'
          },
          {
            label: "No, we don't currently screen women"
          },
          {
            label: 'Other - Write In:',
            value: 'other'
          }
        ]
      },
      screeningProcess: {
        conditions: [
          {
            key: 'screening',
            value: [
              'Yes, all women are routinely screened',
              'Only those considered at risk are screened'
            ]
          }
        ],
        component: 'InputSelectOther',
        label: 'And how is screening currently conducted?',
        options: [
          {
            label: 'Pen-and-paper, manually scored by the health professional'
          },
          {
            label:
              'Digitally, on an iPad/Tablet/Mobile Device in the waiting area or consultation'
          },
          {
            label: 'Digitally, on the clinicians computer'
          },
          {
            label: 'Other',
            value: 'other'
          }
        ]
      },
      screeningDoesWho: {
        conditions: [
          {
            key: 'screeningProcess',
            value: [
              'Digitally, on an iPad/Tablet/Mobile Device in the waiting area or consultation'
            ]
          }
        ],
        component: 'InputSelectOther',
        label:
          'And when completing screening questions on the iPad/Tablet/Mobile Device, is this generally done with the health professional, or privately by the patient/client? (Tick all that apply)',
        options: [
          {
            label: 'Patient completes on their own, in the waiting area'
          },
          {
            label: 'Patient completes on their own, in the consultation'
          },
          {
            label:
              'Patient goes through and verbally completes each question with the health professional'
          },
          {
            label: 'Other',
            value: 'other'
          }
        ]
      },
      screeningResponses: {
        conditions: [
          {
            key: 'screeningProcess',
            value: ['Digitally, on the clinicians computer']
          }
        ],
        component: 'InputSelectOther',
        label:
          'And when the questions are asked from the clinicians desktop computed, are the clients responses entered by the client or the health professional? (Tick all that apply)',
        options: [
          {
            label: 'The client enters their own responses'
          },
          {
            label: 'The professional enters the client responses'
          },
          {
            label: 'A mix of both'
          },
          {
            label: 'Unknown'
          },
          {
            label: 'Other',
            value: 'other'
          }
        ]
      },
      screeningTools: {
        conditions: [
          {
            key: 'screening',
            value: [
              'Yes, all women are routinely screened',
              'Only those considered at risk are screened'
            ]
          }
        ],
        component: 'InputSelectOther',
        label:
          'Which of the following screening tools do you use to access psychosocial risk factors?',
        options: [
          {
            label: 'The Antenatal/Postnatal Risk Questionnaire (ANRQ/PNRQ)'
          },
          {
            label: 'The Safe Start Questions'
          },
          {
            label: 'Other',
            value: 'other'
          }
        ]
      },
      screeningToolsOther: {
        conditions: [
          {
            key: 'screening',
            value: [
              'Yes, all women are routinely screened',
              'Only those considered at risk are screened'
            ]
          }
        ],
        component: 'InputSelectOther',
        label:
          'And thinking about the assessment for mental health symptoms, which of the following screening tools do you use',
        options: [
          {
            label: 'The Edinburgh (Postnatal) Depression Scale (EPDS)'
          },
          {
            label: 'Kessler 10 (K-10)'
          },
          {
            label: 'Other',
            value: 'other'
          }
        ]
      },
      screeningFrequency: {
        conditions: [
          {
            key: 'screening',
            value: [
              'Yes, all women are routinely screened',
              'Only those considered at risk are screened'
            ]
          }
        ],
        component: 'InputSelectOther',
        label:
          'How often is a women offered screening during her pregnancy/postnatal care?',
        options: [
          {
            label: 'Once only'
          },
          {
            label: 'Routinely on two occasions'
          },
          {
            label: 'Once routinely, and again as needed depending on her risk'
          }
        ]
      },
      screeningWhen: {
        conditions: [
          {
            key: 'screening',
            value: [
              'Yes, all women are routinely screened',
              'Only those considered at risk are screened'
            ]
          }
        ],
        component: 'InputText',
        label:
          'And typically, when does screening occur for women within this Service (e.g. 8 week visit, 30 week visit)'
      },
      screeningFathers: {
        component: 'InputSelectOther',
        label:
          'Is screening currently offered to fathers or partners in your Service?',
        options: [
          {
            label: 'Yes'
          },
          {
            label: 'No'
          },
          {
            label: 'Other',
            value: 'other'
          }
        ]
      }
    },
    screeningOther: {
      component: 'InputText',
      label:
        'Are there any other comments that you wish to note about perinatal mental health screening within your setting?'
    }
  },
  {
    type: 'accordion',
    label: 'Health Record Systems',
    content: `
    The next set of questions relate to the health record systems, to help us to scope the opportunity to integrate reports into your existing systems.`,
    fields: {
      healthrecordEmr: {
        component: 'InputSelectOther',
        label:
          'Does your setting use an electronic medical record (EMR) system to electronically store patient information',
        options: [
          {
            label: 'No, we only keep paper-based patient records'
          },
          {
            label:
              'Yes, we have/use an electronic patient record management system'
          },
          {
            label: 'Other',
            value: 'other'
          }
        ]
      },
      healthrecordEmrName: {
        conditions: [
          {
            key: 'healthrecordEmr',
            value: [
              'Yes, we have/use an electronic patient record management system'
            ]
          }
        ],
        component: 'InputText',
        label:
          'Please list below the e-health record system(s) used in this setting (e.g. BOS, e-Maternity, CDIS):'
      },
      healthrecordEmrMove: {
        conditions: [
          {
            key: 'healthrecordEmr',
            value: ['No, we only keep paper-based patient records']
          }
        ],
        component: 'InputSelectOther',
        label:
          'Does your setting have any plans to move to digital health record systems in the future?',
        options: [
          {
            label: 'Yes'
          },
          {
            label: "No, not that I'm aware of"
          },
          {
            label: "I don't know"
          },
          {
            label: 'Other',
            value: 'other'
          }
        ]
      },
      healthrecordOther: {
        conditions: [
          {
            key: 'healthrecordEmrMove',
            value: ['Yes']
          }
        ],
        component: 'InputText',
        label:
          'Please provide us with any details regarding the plans to move to digital records in your Service (e.g name of system, timing).'
      }
    }
  },
  {
    type: 'accordion',
    label: 'Implementation of the iCOPE Digital Screening Program',
    content: `
    <p>The final set of questions ask you to provide us with details regarding your preferred timing of implementation and the key contact people that we can liaise with.</p>
    <p>Please provide the contact details of a nominated iCOPE project lead for your Service. Note: This person will receive a copy of this completed survey upon submission for your records and will be contacted by our implementation team at an appriopriate time to achieve your desired activation date.
    </p>`,
    fields: {
      icopeWhen: {
        component: 'InputDateTimePicker',
        label:
          'Ideally, when would you like to have the iCOPE Digital Screening Platform activated within your Service?'
      },
      icopeNominatedFirstName: {
        component: 'InputText',
        label: 'First Name',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      icopeNominatedLastName: {
        component: 'InputText',
        label: 'Last Name',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      icopeNominatedRole: {
        component: 'InputText',
        label: 'Position',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      icopeNominatedEmail: {
        component: 'InputText',
        label: 'Email Address',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      icopeNominatedLandline: {
        component: 'InputText',
        label: 'Phone Number (landline):'
      },
      icopeNominatedMobile: {
        component: 'InputText',
        label: 'Mobile Phone',
        validations: {
          required: {
            params: null,
            message: 'This field is required'
          }
        }
      },
      icopeConsent: {
        component: 'InputSelectOther',
        label:
          'Would you like to be kept informed of developments relating to the roll-out of the iCOPE Digital Screening Platform? (This simply involves subscribing to an e-newsletter and you can unsubscribe at any time).',
        options: [
          {
            label: 'Yes please',
            value: 'yes'
          },
          {
            label: 'No thanks',
            value: 'no'
          }
        ]
      }
    }
  },
  {
    type: 'accordion',
    label: 'Your IT Contact person details',
    content: `
    <p>As this Program involves digital systems, we will also need to liaise with key Information Technology (IT) Personnel within your organisation.</p>
    <p>Please provide the contact details of a the key Information Technology (IT) contact person that COPE will liaise with to facilitate the inplementation of digital screening and e-record integration within your service.
    </p>`,
    fields: {
      itNominatedFirstName: {
        component: 'InputText',
        label: 'First Name'
      },
      itNominatedLastName: {
        component: 'InputText',
        label: 'Last Name'
      },
      itNominatedRole: {
        component: 'InputText',
        label: 'Position'
      },
      itNominatedEmail: {
        component: 'InputText',
        label: 'Email Address'
        // validations: {
        //   required: {
        //     params: null,
        //     message: 'This field is required'
        //   }
        // }
      },
      itNominatedLandline: {
        component: 'InputText',
        label: 'Phone Number (landline):'
      },
      itNominatedMobile: {
        component: 'InputText',
        label: 'Mobile Phone'
      },
      newsletterContactEmails: {
        label:
          'If you would like COPE to contact your colleagues at other Services, so that we may invite them to complete an expression of interest form for implementation of the iCOPE Digital Screening Platform, please provide their contact details below',
        component: 'InputTextMultiple',
        placeholder: 'Name of colleague, email and phone number.'
      },

      emailTemplateConsent: {
        label:
          'Would you like COPE to provide you with an email template so that you may invite your colleagues at other Services to complete an expression of interest form for implementation of the iCOPE Digital Screening Platform?',
        component: 'InputSelectOther',
        options: [
          {
            label: 'Yes',
            value: 'yes'
          },
          {
            label: 'No',
            value: 'no'
          }
        ]
      },
      emailTemplateFirstName: {
        label: 'First name of the person who will receive the Email template',
        component: 'InputText',
        conditions: [
          {
            key: 'emailTemplateConsent',
            value: ['yes']
          }
        ]
      },
      emailTemplateLastName: {
        label: 'Last name of the person who will receive the Email template',
        component: 'InputText',
        conditions: [
          {
            key: 'emailTemplateConsent',
            value: ['yes']
          }
        ]
      },
      emailTemplateEmailName: {
        label: 'Email of the person who will receive the Email template',
        component: 'InputText',
        conditions: [
          {
            key: 'emailTemplateConsent',
            value: ['yes']
          }
        ]
      }
    }
  },
  {
    type: 'content',
    label: 'Thank you for your time',
    content: `
    <p>
    Thank you for taking our survey - we appreciate that you are busy. Your response is extremely important to us to support the implementation of iCOPE within your Hospital or Health Service.
    </p>
    <p>
    Kind regards
    <br />
    Dr. Nicole Highet<br />
    Founder and Executive Director<br />
    Centre of Perinatal Excellence
    </p>
    `
  }
];

export default schema;
